<template>
    <div v-if="hasPrice || hasExpectedPrice" class="practice-lesson-price">
        <span
            v-if="hasPrice"
            class="badge"
            v-bind:class="mismatch ? 'badge-warning' : 'badge-light'"
            title="Prețul salvat pe lecție"
        >
            {{ info.price }} lei
        </span>
        <span
            v-if="showExpectedPrice"
            class="badge"
            v-bind:class="hasPrice ? 'badge-danger' : 'badge-light'"
            title="Prețul așteptat la data lecției"
        >
            <template v-if="hasPrice">așteptat: </template>{{ info.expected_price }} lei
        </span>
    </div>
</template>

<script>
/**
 * Prices of a practice lesson as seen by the admin.
 *
 * `info.price` is what was frozen on the lesson when it was booked (what the student pays);
 * `info.expected_price` is what the pricing rules say the lesson should cost on its date.
 * When they agree a single badge is shown; when they disagree the expected price is added
 * as a red "așteptat" badge so a mispriced lesson (e.g. saved at 0 lei) stands out.
 */
export default {
    props: {
        info: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        hasPrice() {
            return this.isSet(this.info.price);
        },
        hasExpectedPrice() {
            return this.isSet(this.info.expected_price);
        },
        mismatch() {
            return this.hasPrice && this.hasExpectedPrice && this.info.expected_price !== this.info.price;
        },
        showExpectedPrice() {
            if (!this.hasExpectedPrice) {
                return false;
            }

            return !this.hasPrice || this.mismatch;
        },
    },

    methods: {
        isSet(value) {
            return value !== null && value !== undefined;
        },
    },
};
</script>

<style lang="scss" scoped>
.practice-lesson-price {
    margin-top: 0.25rem;
    white-space: nowrap;

    .badge {
        font-size: 0.8em;
        font-weight: 600;
        padding: 0.3em 0.55em;
    }

    .badge-light {
        border: 1px solid #dee2e6;
    }

    .badge + .badge {
        margin-left: 0.25rem;
    }
}
</style>
